import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import { toast } from "react-toastify";

const TopUpRequest = () => {
//   const { user, loading, refreshUserProfile } = useAuth();
  const { user, loading } = useAuth();
  const [amount, setAmount] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [bankLists, setBankLists] = useState([]);
  const [isBanksLoading, setIsBanksLoading] = useState(true);
  const [historyLists, setHistoryLists] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const getBankAccounts = async () => {
    if (!user?.cid) return;
    setIsBanksLoading(true);
    try {
      const res = await apiService.get(
        `${config.GETBANKSBYCOMPANYID}/${user.parentCompanyId}`,
        100, 
        1
      );
      const activeBanks = (res.data || []).filter(b => b.status === true);
      setBankLists(activeBanks);
    } catch (error) {
      console.error("Error fetching banks:", error);
    } finally {
      setIsBanksLoading(false);
    }
  };

  const getHistoryData = async (pageNum) => {
    if (!user?.cid) return;
    setIsHistoryLoading(true);
    try {
      const response = await apiService.get(
        `${config.GETTOPUPHISTORYBYCOMPANYID}/${user.cid}`,
        pageSize,
        pageNum
      );
      setHistoryLists(response.data || []);
      setPageNumber(response.pageNumber);
      setTotalPages(response.totalPages);
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setIsHistoryLoading(false);
    }
  };

  
  const handleTopUpRequest = async (e) => {
    e.preventDefault();

    if (!amount || amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    setIsRequesting(true);
    try {
      const payload = {
        amount: parseFloat(amount),
        companyId: user.cid, 
        status: "REQUESTED",
      };

      await apiService.create(config.CREATECOMPANYWALLET, payload);
      
      setAmount(""); 
      getHistoryData(1);
    } catch (error) {
      console.error("Error creating top up:", error);
      toast.error("Failed to submit request.");
    } finally {
      setIsRequesting(false);
    }
  };

  
  const GetPreviousPageData = () => {
    if (pageNumber > 1) getHistoryData(pageNumber - 1);
  };
  const GetNextPageData = () => {
    if (pageNumber < totalPages) getHistoryData(pageNumber + 1);
  };
  const GetPageData = (number) => {
    getHistoryData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === pageNumber ? "active" : "";
    return (
      <li
        className={`page-item ${isActive}`}
        key={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

    useEffect(() => {
    if (!loading && user) {
    //   refreshUserProfile(); 
      getBankAccounts();    
      getHistoryData(1);  
    }
  }, [loading]);

  if (loading || !user) {
    return <div className="page-content">Loading...</div>;
  }

  return (
          <div className="container-fluid mt-2">
            {/* Current Balance Display (Optional but helpful) */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="alert alert-info border-0 shadow-sm" role="alert">
                        Current Wallet Balance: <strong>{user.walletBalance ?? 0}</strong>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
        <div className="col-12">
          <div className="alert alert-warning border-0 shadow-sm" role="alert" style={{ borderLeft: "5px solid #ffc107" }}>
            <div className="d-flex">
              <div className="flex-shrink-0">
                <i className="ri-information-fill fs-4 text-warning"></i>
              </div>
              <div className="flex-grow-1 ms-3">
                <h5 className="alert-heading fs-16 fw-bold">Important Instructions</h5>
                <p className="mb-0">
                  Please ensure you have <strong>transferred the amount</strong> to one of our bank accounts listed below <strong>before</strong> submitting this top-up request. 
                </p>
                <p className="mt-1 mb-0">
                  Once your request is submitted, our team will verify the bank transaction and update your wallet balance within a short period.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

            <div className="row">
              {/* --- LEFT BLOCK: REQUEST FORM --- */}
              <div className="col-lg-4">
                <div className="card h-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Request Top Up</h4>
                  </div>
                  <div className="card-body">
                    <p className="text-muted">
                      Enter the amount you transferred to our bank account.
                    </p>
                    <form onSubmit={handleTopUpRequest}>
                      <div className="mb-3">
                        <label className="form-label">Amount</label>
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            min="1"
                            required
                          />
                        </div>
                      </div>
                      <div className="d-grid">
                        <button 
                            type="submit" 
                            className="btn btn-primary" 
                            disabled={isRequesting}
                        >
                          {isRequesting ? "Submitting..." : "Submit Request"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* --- RIGHT BLOCK: BANK ACCOUNTS LIST --- */}
              <div className="col-lg-8">
                <div className="card h-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Our Bank Accounts</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                        {isBanksLoading ? (
                            <div className="text-center p-3">Loading Banks...</div>
                        ) : (
                            <table className="table table-borderless table-sm">
                                <thead className="table-light">
                                <tr>
                                    <th>Bank Name</th>
                                    <th>Account Name</th>
                                    <th>Account No</th>
                                    <th>IFSC / Branch</th>
                                </tr>
                                </thead>
                                <tbody>
                                {bankLists.length > 0 ? (
                                    bankLists.map((bank) => (
                                    <tr key={bank.companyBankAccountId}>
                                        <td className="fw-medium">{bank.bankName}</td>
                                        <td>{bank.accountName}</td>
                                        <td className="text-primary fw-bold">{bank.accountNo}</td>
                                        <td>
                                            {bank.ifsc} <br/>
                                            <small className="text-muted">{bank.branch}</small>
                                        </td>
                                    </tr>
                                    ))
                                ) : (
                                    <tr>
                                    <td colSpan="4" className="text-center text-muted">
                                        No active bank accounts found.
                                    </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* --- BOTTOM BLOCK: HISTORY TABLE --- */}
            <div className="row mt-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Transaction History</h4>
                  </div>
                  <div className="card-body">
                    {isHistoryLoading ? (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped table-hover align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>S.No</th>
                              <th>Date</th>
                              <th>Status</th>
                              <th className="text-end">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {historyLists.length > 0 ? (
                              historyLists.map((item, index) => {
                                const isCredit = item.status === "CREDITED";
                                return (
                                  <tr key={item.companyWalletId}>
                                    <td>{(pageNumber - 1) * pageSize + (index + 1)}</td>
                                    <td>
                                      {moment(item.updatedDate).format("DD MMM YYYY, hh:mm A")}
                                    </td>
                                    <td>
                                      {item.status === "REQUESTED" ? (
                                         <span className="badge bg-warning-subtle text-warning">Requested</span>
                                      ) : isCredit ? (
                                        <span className="badge bg-success-subtle text-success">Credited</span>
                                      ) : (
                                        <span className="badge bg-danger-subtle text-danger">Debited</span>
                                      )}
                                    </td>
                                    <td className={`text-end fw-bold ${isCredit ? "text-success" : item.status === "REQUESTED" ? "text-warning" : "text-danger"}`}>
                                      {isCredit ? "+" : ""}{item.amount}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center text-muted">
                                  No transaction history found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Pagination */}
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                        <div className="flex-shrink-0">
                            <div className="text-muted">
                            Showing <span className="fw-semibold">{historyLists.length}</span> of{" "}
                            <span className="fw-semibold">{totalRecords}</span> Results
                            </div>
                        </div>
                        <ul className="pagination pagination-separated pagination-sm mb-0">
                            <li className={`page-item ${pageNumber <= 1 ? "disabled" : ""}`} onClick={GetPreviousPageData}>
                                <Link className="page-link" to="#">Previous</Link>
                            </li>
                            {renderPageNumbers}
                            <li className={`page-item ${pageNumber >= totalPages ? "disabled" : ""}`} onClick={GetNextPageData}>
                                <Link className="page-link" to="#">Next</Link>
                            </li>
                        </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
  );
};

export default TopUpRequest;